import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { MessageType } from '@core/enums/MessageType.enum';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports:[CommonModule],
  template: `
  <div  id="toast-simple" [ngClass]="{'text-green-400 bg-green-100 divide-green-400': isSuccess(), 'text-red-400 bg-red-100 divide-red-400': !isSuccess()}"class="fixed bottom-10 left-1/2 transform -translate-x-1/2 flex items-center p-4 space-x-4 rtl:space-x-reverse divide-x rtl:divide-x-reverse rounded-lg pr-8"
  role="alert">
    @if(messageType() === MessageTypes.SAVED){
      <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5"/>
      </svg>
    }
    @else if(messageType() === MessageTypes.DELETED) {
      <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"/>
      </svg>
    }
    @else if(messageType() === MessageTypes.ERROR){
      <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 5 9 4V3m5 2 1-1V3m-3 6v11m0-11a5 5 0 0 1 5 5m-5-5a5 5 0 0 0-5 5m5-5a4.959 4.959 0 0 1 2.973 1H15V8a3 3 0 0 0-6 0v2h.027A4.959 4.959 0 0 1 12 9Zm-5 5H5m2 0v2a5 5 0 0 0 10 0v-2m2.025 0H17m-9.975 4H6a1 1 0 0 0-1 1v2m12-3h1.025a1 1 0 0 1 1 1v2M16 11h1a1 1 0 0 0 1-1V8m-9.975 3H7a1 1 0 0 1-1-1V8"/>
      </svg>
    }
    <div class="ps-4 text-sm font-normal">{{message()}}</div>
  </div>
  `
})
export class ToastComponent {
  readonly MessageTypes = MessageType;
  messageType = input.required<MessageType | undefined>();
  message = input.required<string>();
  isSuccess = computed(() => this.messageType() === MessageType.SAVED ||  this.messageType() === MessageType.DELETED);
}
